import SlideManager from "../utils/slide-manager";
import FillTheBlanksQuiz from "./fillInTheBlanksQuiz.js";

class SlideQuiz {
    constructor({
        active = false,
        halfscreen = null,
        layout = null,
        layoutMobile = 'regular',
        type = "radio",
        hideQuizBox = false,
        required = false,
        mathJax = false,
        score = 10,
        numerator = 0,
        denominator = 1,
        timeLimitEnabled = false,
        scoreBasedActionEnabled = false,
        scoreActions = [],
        answerBasedFeedbackEnabled = false,
        feedbackAnswers = [""],
        answerBasedFeedbacks = ["", "", "", ""],
        flashCardIds = {},
        randomOrder = false,
        practiceOnly = false,
        answersCountCond = false,
        timeLimit = 30,
        answers = ["", "", ""],
        hints = [{ type: "text", value: "", uuid: [] }],
        // hints = Array.from(new Array(3)).map(a => ({type: "text", value: "", uuid: []})),
        meshes = [],
        regions = [],
        nodes = [],
        squareNodes = false,
        connections = [],
        circleColor = "#51bae8",
        lineColor = "rgb(255, 255, 255)",
        circleTextColor = "rgb(255, 255, 255)",
        labels = {},
        rightAnswer = "",
        slide = SlideManager.activeSlide,
        flashCardSideA = "definition",
        flashCardSideB = "name",
        question = "",
        questionFontSize = 1,
        position = { x: 0, y: 0 },
        positionSm = { x: 0, y: 0 },
        partialCredit = false,
        hasAudio = false,
        enabledCorrectAudio = false,
        enabledIncorrectAudio = false,
        correctAudio = false,
        incorrectAudio = false,

        correctAssessment = {
            solutionEnabled: false,
            solutionText: "",
            audioEnabled: false,
            audioUuid: null,
            targetSlide: null,
        },
        incorrectAssessment = {
            solutionEnabled: false,
            solutionText: "",
            audioEnabled: false,
            audioUuid: null,
            targetSlide: null,
        },

        isRetakable = true,
        use2DSnapping = true,
        carObject = null,
        carDirection = "free",
        carComparator = "moreEq",
        carVelocity = 25,
        carVelRatio = 0.5,
        carUseRatio = false,
        carUseAbsVal = false,
        carDuration = 3,
        matrixRows = 4,
        matrixCols = 4,
        radioQuiz,
        dragDrop2dQuiz = {},
        fillTheBlanksQuiz = { ftbType: "capsule", question: ["Insert ", " answer and type another ", " answer"], answers: [{ type: "capsule", value: "correct" }, { type: "capsule", value: "correct" }], wrongAnswers: "wrong; another wrong" },
        boolChoices = JSON.stringify({
            TRUE: "TRUE",
            FALSE: "FALSE"
        }),
        actionsOnSubmit = false,
        actions = [],
        fuzzySelection = false,
        embibeQuestionId = null,
        embibeConvertedQuestionId = null,
        invertImages = false,
        isCommutable = false,
        isSwitchedDirection = false,
        displayDropzone = false,
        useSnapping = true,
        isHideUI = false,
        isTextJustified = false,
        answerByRotation = false,
        removeMathSpacing = false,
        selectRootsOnly = false,
    } = {}) {
        this.isCommutable = isCommutable;
        this.isSwitchedDirection = isSwitchedDirection;
        this.displayDropzone = displayDropzone;
        this.useSnapping = useSnapping;
        this.isSlideQuiz = true;
        this.layout = layout ? layout : halfscreen ? "halfscreen" : null;
        this.layoutMobile = layoutMobile;
        this.userScore = 0;
        this.active = active;
        this.type = type;
        this.hideQuizBox = hideQuizBox;
        this.required = required;
        this.mathJax = mathJax;
        this.score = score;
        this.numerator = numerator;
        this.denominator = denominator;
        this.timeLimitEnabled = timeLimitEnabled;
        this.scoreBasedActionEnabled = scoreBasedActionEnabled;
        this.answerBasedFeedbackEnabled = answerBasedFeedbackEnabled;
        this.scoreActions = scoreActions;
        this.feedbackAnswers = feedbackAnswers;
        this.answerBasedFeedbacks = answerBasedFeedbacks;
        this.flashCardIds = flashCardIds;
        this.flashCardSideA = flashCardSideA;
        this.flashCardSideB = flashCardSideB;
        this.randomOrder = randomOrder;
        this.practiceOnly = practiceOnly;
        this.answersCountCond = answersCountCond;
        this.timeLimit = timeLimit;
        this.answers = answers;
        this.hints = hints.map(h => typeof h === "string" ? ({ type: "text", value: h, uuid: [] }) : h);
        this.hintsEnabled = this.hints.filter(h => h.value).length;
        this.meshes = meshes;
        this.regions = regions;
        this.squareNodes = squareNodes;
        this.nodes = nodes;
        this.connections = connections;
        this.circleColor = circleColor;
        this.lineColor = lineColor;
        this.circleTextColor = circleTextColor;
        this.labels = labels;
        this.rightAnswer = rightAnswer;
        this.slide = slide;
        this.question = question;
        this.questionFontSize = questionFontSize;
        this.position = position;
        this.positionSm = positionSm;
        this.partialCredit = partialCredit;
        this.hasAudio = hasAudio;

        this.correctAssessment = correctAssessment;
        this.incorrectAssessment = incorrectAssessment;

        this.correctAudio = correctAudio;
        this.incorrectAudio = incorrectAudio;
        this.isRetakable = isRetakable;
        this.use2DSnapping = use2DSnapping;
        this.carObject = carObject;
        this.carDirection = carDirection;
        this.carComparator = carComparator;
        this.carVelocity = carVelocity;
        this.carVelRatio = carVelRatio;
        this.carUseRatio = carUseRatio;
        this.carUseAbsVal = carUseAbsVal;
        this.carDuration = carDuration;
        this.boolChoices = boolChoices;
        this.matrixRows = matrixRows;
        this.matrixCols = matrixCols;
        this.actionsOnSubmit = actionsOnSubmit;
        this.actions = actions;
        this.embibeQuestionId = embibeQuestionId;
        this.embibeConvertedQuestionId = embibeConvertedQuestionId;
        this.invertImages = invertImages;
        if (this.type === "ferris" && !this.rightAnswer) this.rightAnswer = "wheel";
        if (this.type === "radio" && !this.layout) this.layout = "twoColumns";
        this.initRadioQuiz(radioQuiz);
        this.dragDrop2dQuiz = new DragDrop2DQuiz(dragDrop2dQuiz);
        if (type === "text") {
            this.type = "ftb";
            fillTheBlanksQuiz.ftbType = "input"
            fillTheBlanksQuiz.question = question.split(/__+/g).length === 2 ? question.split(/_+/g) : [question + " \n", ""];
            fillTheBlanksQuiz.answers = [{ type: "input", value: rightAnswer }]
        }
        if (type === "ftb"
            && question.split(/__+/g).length === 2
            && fillTheBlanksQuiz.ftbType === "input"
            && fillTheBlanksQuiz.answers
            && fillTheBlanksQuiz.answers.length === 1) {
            fillTheBlanksQuiz.question = question.split(/__+/g);
            fillTheBlanksQuiz.answers = [{ type: "input", value: rightAnswer }]
            this.question = "";
        }
        this.fillTheBlanksQuiz = new FillTheBlanksQuiz(fillTheBlanksQuiz);
        this.fuzzySelection = fuzzySelection;
        this.isHideUI = isHideUI;
        this.isTextJustified = isTextJustified;
        this.answerByRotation = answerByRotation;
        this.removeMathSpacing = removeMathSpacing;
        this.selectRootsOnly = selectRootsOnly;
    }

    initRadioQuiz(radioQuiz) {
        this.radioQuiz = new RadioQuiz(radioQuiz);

        if (!radioQuiz) {
            this.radioQuiz.initFromOldQuiz(this);
        }

        // force single-answer mode for quizzes that only have one correct answer
        this.radioQuiz.multipleCorrect = this.radioQuiz.answers.reduce((accum, answer) => accum + (answer.correct ? 1 : 0), 0) !== 1;
    }
}

class RadioQuiz {
    constructor({
        answers = [],
        randomOrder = false,
        multipleCorrect = false,
    } = {}) {
        this.answers = [];
        for (let answer of answers) {
            this.answers.push(new RadioQuizAnswer(answer));
        }

        this.randomOrder = false;
        this.multipleCorrect = multipleCorrect;
    }

    initFromOldQuiz({ answers, rightAnswer }) {
        this.answers.push(new RadioQuizAnswer({ text: rightAnswer, correct: true }));
        for (let answer of answers) {
            this.answers.push(new RadioQuizAnswer({ text: answer, correct: false }));
        }

        this.randomOrder = true;
        this.multipleCorrect = false;
    }
}

class RadioQuizAnswer {
    constructor({ text = '', correct = false } = {}) {
        this.text = text;
        this.correct = correct;
    }
}

class DragDrop2DQuiz {
    constructor({
        images = [],
        regions = [],
    } = {}) {
        this.images = images;
        this.regions = regions;
    }

    remove(uuid) {

        let imageInd = this.images.findIndex(i => i.image === uuid);
        if (imageInd !== -1) {
            this.images.splice(imageInd, 1);
        }

        let regionInd = this.regions.findIndex(r => r === uuid);
        if (regionInd !== -1) {
            this.regions.splice(regionInd, 1);
        }

        this.images.forEach(i => {
            let regionInd = i.regions.findIndex(r => r === uuid);
            if (regionInd !== -1) {
                i.regions.splice(regionInd, 1);
            }
        })
    }
}

class DragDrop2DQuizImage {
    constructor({
        image = null,
        regions = [],
    } = {}) {
        this.image = image
        this.regions = regions;
    }
}

export default SlideQuiz;
export { SlideQuiz, RadioQuizAnswer, DragDrop2DQuizImage };
